<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="newUserLabel" i18n="@@CreateNewCustomerHeader">Neuen Kunden anlegen</h5>
      <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
    </div>
    <div class="modal-body">
      <app-create-customer #createCustomerComponent [customerId]="null" (newCustomerEvent)="newCustomerEvent($event)"></app-create-customer>
    </div>
    <div class="modal-footer">
      <button type="button" id="cancel" class="btn btn-yellow"  data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Abbrechen</button>
      <form [formGroup]="formService.form" (ngSubmit)="createCustomerComponent.onSubmit(formService.form.value)">
        <button type="submit" id="invite" class="btn btn-primary" [disabled]="getButtonDisabled()" i18n="@@InviteButton">Einladen</button>
      </form>
    </div>
  </div>
</div>
<div class="modal-body">
  <app-create-customer #createCustomerComponent [customerId]="null" (newCustomerEvent)="newCustomerEvent($event)"></app-create-customer>
</div>
<div class="modal-footer">
  <button type="button" id="cancel" class="btn btn-danger text-white"  data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Abbrechen</button>
  <form [formGroup]="formService.form" (ngSubmit)="createCustomerComponent.onSubmit(formService.form.value)">
    <button type="submit" id="invite" class="btn btn-yellow" [disabled]="getButtonDisabled()" i18n="@@InviteButton">Einladen</button>
  </form>
</div>
